import { render, staticRenderFns } from "./select-transport.vue?vue&type=template&id=09502a30&"
import script from "./select-transport.vue?vue&type=script&lang=js&"
export * from "./select-transport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports